import React, { useEffect, useMemo, useRef, useState } from "react";
import { ToastContainer } from "react-toastify";
import Sidebar from "../../components/admin/sidebar/Sidebar";
import useDash from "../../assets/css/dash.module.css";
import { FontColor, FourGround } from "../../assets/js/theme";
import { useTranslation } from "react-i18next";
import Loader from "../../components/common/Loader";
import {
  ArrowBarLeft,
  ArrowBarRight,
  ArrowClockwise,
  FilterCircle,
  PrinterFill,
  Wallet2,
} from "react-bootstrap-icons";
import Footer from "../../components/admin/footer/Footer";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllBills,
  getArea,
  getSubAreas,
} from "../../features/apiCallReseller";
import moment from "moment";
import Table from "../../components/table/Table";
import FormatNumber from "../../components/common/NumberFormat";
import ReactToPrint from "react-to-print";
import PrintReport from "./ReportPDF";
import { Accordion, Badge, Card, Collapse } from "react-bootstrap";
import WithdrawOnlinePayment from "./WithdrawOnlinePayment";
import NetFeeBulletin from "../../components/bulletin/NetFeeBulletin";
import { getBulletinPermission } from "../../features/apiCallAdmin";
import ReportView from "../../pages/report/modal/ReportView";
import { adminResellerCommission } from "../../pages/reseller/resellerCollection/CommissionShear";
import useISPowner from "../../hooks/useISPOwner";
import { badge } from "../../components/common/Utils";
import DataFilter from "../../pages/common/DataFilter";
import useDataState from "../../hooks/useDataState";
import useSelectorState from "../../hooks/useSelectorState";
import { getAllPackages } from "../../features/apiCalls";

const Report = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const componentRef = useRef();

  // date & time find
  var today = new Date();
  var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);

  firstDay.setHours(0, 0, 0, 0);
  today.setHours(23, 59, 59, 999);

  const filterInputPermission = {
    month: true,
    mikrotik: true,
    package: true,
    area: true,
    subArea: true,
    poleBox: true,
    collectedBy: true,
    billType: true,
    billingType: true,
    medium: true,
    startCreateDate: true,
    endCreateDate: true,
  };

  //---> Get filtered dataset from useDataState hook
  const { filterOptions, setFilterOption } = useDataState();

  // get user & current user data form useISPOwner
  const { role, userData, resellerData } = useISPowner();

  //---> Get redux store state data from useSelectorState hooks
  const { areas, subAreas } = useSelectorState();

  // get isp owner data
  const bpSettings = useSelector(
    (state) => state.persistedReducer.auth.ispOwnerData?.bpSettings,
  );

  // get reseller, collector collection all bills
  const allBills = useSelector((state) => state.payment.allBills);

  // get reseller all users data from redux store
  const resellerUsers = useSelector((state) => state.reseller.resellerUsers);

  // get bulletin permission
  const butPermission = useSelector(
    (state) => state.adminNetFeeSupport?.bulletinPermission,
  );

  // reseller id from role base
  const resellerId = role === "collector" ? userData.reseller : userData.id;
  const resellerInfo = role === "collector" ? resellerData : userData;

  // Loading state
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  const [billReport, setBillReport] = useState([]);

  // filter Accordion handle state
  const [activeKeys, setActiveKeys] = useState("");

  // report note view id
  const [viewId, setViewId] = useState();

  useEffect(() => {
    if (filterOptions?.month !== undefined) {
      var createStart = new Date(
        filterOptions?.month?.getFullYear(),
        filterOptions?.month?.getMonth(),
        1,
      );
      var createEnd = new Date(
        filterOptions?.month?.getFullYear(),
        filterOptions?.month?.getMonth() + 1,
        0,
      );
      createEnd.setHours(23, 59, 59, 999);

      if (createEnd?.getMonth() + 1 === today.getMonth() + 1) {
        setFilterOption({
          ...filterOptions,
          startCreateDate: createStart,
          endCreateDate: today,
        });
      } else {
        setFilterOption({
          ...filterOptions,
          startCreateDate: createStart,
          endCreateDate: createEnd,
        });
      }

      filterOptions?.month?.getMonth() + 1 &&
        getAllBills(
          dispatch,
          userData.id,
          filterOptions?.month?.getFullYear(),
          filterOptions?.month?.getMonth() + 1,
          setIsLoading,
        );
    }
  }, [filterOptions?.month]);

  useEffect(() => {
    if (!allBills) return;

    setBillReport(allBills);
  }, [allBills]);

  useEffect(() => {
    //---> @Get ispOwner areas data
    !areas?.length && getArea(dispatch, resellerId, setLoading);

    //---> @Get reseller ispOwner areas sub-area data
    !subAreas.length && getSubAreas(dispatch, resellerId);

    Object.keys(butPermission)?.length === 0 && getBulletinPermission(dispatch);
  }, []);

  // reload handler
  const reloadHandler = () => {
    getAllBills(
      dispatch,
      userData.id,
      filterOptions?.month?.getFullYear(),
      filterOptions?.month?.getMonth() + 1,
      setIsLoading,
    );
  };

  // select area & collector find
  const area = areas.find((item) => item.id === filterOptions?.area);
  const subArea = subAreas.find((item) => item.id === filterOptions?.subArea);
  const collector = resellerUsers.find(
    (item) => item.id === filterOptions?.collectedBy,
  );

  // collection bill report print pdf
  const filterData = {
    area: area?.name ? area.name : t("all"),
    subArea: subArea?.name ? subArea.name : t("all"),
    collector: collector?.name ? collector.name : t("all"),
    startDate: moment(filterOptions?.startCreateDate).format("YYYY-MM-DD"),
    endDate: moment(filterOptions?.endCreateDate).format("YYYY-MM-DD"),
    totalBill: billReport?.reduce((prev, current) => prev + current.amount, 0),
  };

  //billing data show columns
  const columns = useMemo(
    () => [
      {
        width: "5%",
        Header: t("id"),
        accessor: (field) =>
          field?.hotspotCustomer
            ? field?.hotspotCustomer?.customerId
            : field?.customer?.customerId,
        Cell: ({ row: { original } }) => (
          <div>
            <p className="text-center">
              {original?.hotspotCustomer
                ? original?.hotspotCustomer?.customerId
                : original?.customer?.customerId}
            </p>
            <Badge
              bg={
                original.customer?.userType === "pppoe"
                  ? "primary"
                  : original.customer?.userType === "static"
                    ? "info"
                    : "secondary"
              }
            >
              {original.customer?.userType === "pppoe"
                ? "PPPoE"
                : original.customer?.userType === "static"
                  ? "Static"
                  : original.hotspotCustomer?.userType === "hotspot"
                    ? "Hotspot"
                    : ""}
            </Badge>
          </div>
        ),
      },
      {
        width: "15%",
        Header: t("pppoeIp"),
        accessor: (field) =>
          `${
            field?.hotspotCustomer
              ? field?.hotspotCustomer?.name
              : field?.customer?.name
          } ${
            field.customer?.userType === "pppoe"
              ? field.customer?.pppoe?.name
              : field.customer?.userType === "static"
                ? field.customer?.queue?.target
                : field?.hotspotCustomer?.hotspot?.name
          }`,
        Cell: ({ row: { original } }) => {
          const customer = original?.customer;
          const hotspotCustomer = original?.hotspotCustomer;

          const name = hotspotCustomer?.name || customer?.name;

          let addressInfo = "";
          if (customer?.userType === "pppoe") {
            addressInfo = customer?.pppoe?.name;
          } else if (customer?.userType === "static") {
            addressInfo = customer?.queue?.target;
          } else {
            addressInfo = hotspotCustomer?.hotspot?.name;
          }

          return (
            <div className="text-start">
              <p>{name}</p>
              <p>{addressInfo}</p>
            </div>
          );
        },
      },
      {
        width: "13%",
        Header: t("packageBill"),
        accessor: (field) =>
          field.customer?.mikrotikPackage?.name
            ? field.customer?.mikrotikPackage?.name
            : field.customer?.userType === "pppoe"
              ? field.customer?.pppoe?.profile
              : field?.hotspotCustomer?.hotspot.profile,
        Cell: ({ row: { original } }) => {
          return (
            <div>
              <p>
                {original.customer?.userType === "pppoe"
                  ? original.customer?.mikrotikPackage?.name
                  : original.customer?.userType === "static"
                    ? `${
                        original.customer?.uploadPackage
                          ? original.customer?.uploadPackage?.name
                          : original.customer?.mikrotikPackage?.name
                      }/${
                        original.customer?.downloadPackage
                          ? original.customer?.downloadPackage?.name
                          : original.customer?.mikrotikPackage?.name
                      }`
                    : original.hotspotCustomer?.hotspotPackage?.name}
              </p>
              <p style={{ fontWeight: "500" }}>৳{original?.amount}</p>
            </div>
          );
        },
      },
      {
        width: "7%",
        Header: t("due"),
        accessor: "due",
      },
      {
        width: "8%",
        Header: t("billType"),
        accessor: "billType",
      },
      {
        width: "12%",
        Header: t("TypeMedium"),
        accessor: (field) => `${field?.billingType} ${field?.medium}`,
        Cell: ({ row: { original } }) => {
          return (
            <div>
              <p style={{ fontWeight: "500" }}>{original?.medium}</p>
              <p>{badge(original?.billingType)}</p>
            </div>
          );
        },
      },
      {
        width: "8%",
        Header: t("collected"),
        accessor: "name",
      },
      {
        width: "12%",
        Header: t("otherCommission"),
        Cell: ({ row: { original } }) => (
          <div className="text-start">
            <p>
              {t("admin")} &nbsp;
              <span style={{ fontWeight: "500" }}>
                ৳
                {original?.ispOwnerCommission
                  ? original?.ispOwnerCommission
                  : adminResellerCommission(
                      resellerInfo,
                      {
                        ...original,
                        customer: {
                          ...original?.customer,
                          mikrotikPackage:
                            original?.customer?.mikrotikPackage?._id,
                        },
                      },
                      "reseller",
                    )?.ispOwnerCommission}
              </span>
            </p>

            <p>
              {t("own")} &nbsp;
              <span style={{ fontWeight: "500" }}>
                ৳
                {original?.resellerCommission
                  ? original?.resellerCommission
                  : adminResellerCommission(
                      resellerInfo,
                      {
                        ...original,
                        customer: {
                          ...original?.customer,
                          mikrotikPackage:
                            original?.customer?.mikrotikPackage?._id,
                        },
                      },
                      "reseller",
                    )?.resellerCommission}
              </span>
            </p>
          </div>
        ),
      },
      {
        width: "8%",
        Header: t("note"),
        accessor: (data) => {
          return {
            id: data.id,
            note: data.note,
            start: data.start,
            end: data.end,
            month: data.month,
          };
        },
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <p>
                {value.note && value.note.slice(0, 15)}
                <span>{value?.note && value?.note?.length > 15 && "..."}</span>
              </p>
              {value?.start && value?.end && (
                <span className="badge bg-secondary">
                  {moment(value.start).format("YYYY/MM/DD")}
                  {moment(value.end).format("YYYY/MM/DD")}
                </span>
              )}
              <p>
                {value?.month && value.month.slice(0, 15)}
                <span>
                  {value?.month && value?.month?.length > 15 && "..."}
                </span>
              </p>
            </>
          );
        },
      },
      {
        width: "12%",
        Header: t("date"),
        accessor: "createdAt",
        Cell: ({ cell: { value } }) => {
          return moment(value).format("YYYY/MM/DD hh:mm A");
        },
      },
    ],
    [t],
  );

  //function to calculate total Commissions and other amount
  const totalSum = () => {
    const initialValue = {
      amount: 0,
      onlineCollection: 0,
      resellerCommission: 0,
      ispOwnerCommission: 0,
    };

    const calculatedValue = billReport?.reduce((previous, current) => {
      //total amount
      previous.amount += current.amount;

      // sum of all reseller commission
      previous.resellerCommission += current?.resellerCommission
        ? current?.resellerCommission
        : adminResellerCommission(
            resellerInfo,
            {
              ...current,
              customer: {
                ...current?.customer,
                mikrotikPackage: current?.customer?.mikrotikPackage?._id,
              },
            },
            "reseller",
          ).resellerCommission;

      // sum of all ispOwner commission
      previous.ispOwnerCommission += current?.ispOwnerCommission
        ? current?.ispOwnerCommission
        : adminResellerCommission(
            resellerInfo,
            {
              ...current,
              customer: {
                ...current?.customer,
                mikrotikPackage: current?.customer?.mikrotikPackage?._id,
              },
            },
            "reseller",
          ).ispOwnerCommission;

      previous.onlineCollection += [
        "sslcommerz",
        "uddoktapay",
        "bKashPG",
      ].includes(current?.medium)
        ? current?.resellerCommission
          ? current?.resellerCommission
          : adminResellerCommission(resellerInfo, current, "reseller")
              .resellerCommission
        : 0;

      return previous;
    }, initialValue);

    return calculatedValue;
  };

  const customComponent = (
    <div
      className="text-center"
      style={{ fontSize: "18px", fontWeight: "500", display: "flex" }}
    >
      {totalSum()?.amount > 0 && (
        <div>
          {t("collection")} :
          <span className="fw-bold"> ৳{FormatNumber(totalSum().amount)}</span>
        </div>
      )}
      <div className="mx-3">
        {t("admin")} :
        <span className="fw-bold">
          &nbsp; ৳{FormatNumber(totalSum().ispOwnerCommission)}
        </span>
      </div>
      <div>
        {t("own")} :
        <span className="fw-bold">
          &nbsp;৳{FormatNumber(totalSum().resellerCommission)}
        </span>
      </div>
    </div>
  );

  return (
    <>
      <Sidebar />
      <ToastContainer position="top-right" theme="colored" />
      <div className={useDash.dashboardWrapper}>
        <div className="container-fluied collector">
          <div className="container">
            <FontColor>
              <div className="collectorTitle d-flex justify-content-between px-4">
                <div>{t("billReport")}</div>

                <div className="d-flex justify-content-center align-items-center"></div>

                <div
                  style={{ height: "45px" }}
                  className="d-flex align-items-center"
                >
                  <div
                    onClick={() => {
                      if (!activeKeys) {
                        setActiveKeys("filter");
                      } else {
                        setActiveKeys("");
                      }
                    }}
                    title={t("filter")}
                  >
                    <FilterCircle className="addcutmButton" />
                  </div>

                  <div className="reloadBtn">
                    {isLoading ? (
                      <Loader />
                    ) : (
                      <ArrowClockwise
                        className="arrowClock"
                        title={t("refresh")}
                        onClick={() => reloadHandler()}
                      />
                    )}
                  </div>

                  <Collapse in={open} dimension="width">
                    <div id="example-collapse-text">
                      <Card className="cardCollapse border-0">
                        <div className="d-flex align-items-center">
                          {bpSettings?.hasPG && !userData?.settings?.hasPG && (
                            <div
                              className="addAndSettingIcon"
                              onClick={() => setShow(true)}
                              title={t("withdrawal request")}
                            >
                              <Wallet2 className="addcutmButton" />
                            </div>
                          )}

                          <ReactToPrint
                            documentTitle={t("CustomerList")}
                            trigger={() => (
                              <PrinterFill
                                title={t("print")}
                                className="addcutmButton"
                              />
                            )}
                            content={() => componentRef.current}
                          />
                        </div>
                      </Card>
                    </div>
                  </Collapse>

                  {!open && (
                    <ArrowBarLeft
                      className="ms-1"
                      size={34}
                      style={{ cursor: "pointer" }}
                      onClick={() => setOpen(!open)}
                      aria-controls="example-collapse-text"
                      aria-expanded={open}
                    />
                  )}

                  {open && (
                    <ArrowBarRight
                      className="ms-1"
                      size={34}
                      style={{ cursor: "pointer" }}
                      onClick={() => setOpen(!open)}
                      aria-controls="example-collapse-text"
                      aria-expanded={open}
                    />
                  )}
                </div>
              </div>

              <FourGround>
                <div className="mt-2">
                  <Accordion alwaysOpen activeKey={activeKeys}>
                    <Accordion.Item eventKey="filter">
                      <Accordion.Body>
                        <DataFilter
                          filterData={allBills}
                          setFilterData={setBillReport}
                          filterOptions={filterOptions}
                          setFilterOption={setFilterOption}
                          inputPermission={filterInputPermission}
                        />
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>

                  <div className="collectorWrapper pb-2">
                    <div className="addCollector">
                      {/* print report */}
                      <div style={{ display: "none" }}>
                        <PrintReport
                          filterData={filterData}
                          currentCustomers={billReport}
                          ref={componentRef}
                        />
                      </div>
                      {/* print report end*/}

                      <div className="table-section">
                        <Table
                          customComponent={customComponent}
                          isLoading={isLoading}
                          columns={columns}
                          data={billReport}
                        ></Table>
                      </div>
                    </div>
                  </div>
                </div>

                {(butPermission?.collectionReport ||
                  butPermission?.allPage) && <NetFeeBulletin />}
              </FourGround>
              <Footer />
            </FontColor>
          </div>
        </div>
      </div>

      {bpSettings?.hasPG && !userData?.settings?.hasPG && (
        <WithdrawOnlinePayment
          show={show}
          setShow={setShow}
          balance={totalSum()?.onlineCollection}
        />
      )}

      <ReportView reportId={viewId} status="resellerCollection" />
    </>
  );
};

export default Report;
